import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {Trans} from 'react-i18next';
import classnames from 'classnames';
import {useDispatch, useSelector} from 'react-redux';
import {openTour} from '../../tutorial/reducer';
import TutorialModal from '../../tutorial';
import frontendUtils from '../../../utils/frontendUtils';
import {history} from '../../../utils/redux/store';
import moment from 'moment';
import _get from 'lodash/get';
import useWindowWidth from '../../hook/useWindowWidth';

export default React.memo(function Help() {
  const [show, setShow] = useState(false);
  const accountSummary = useSelector(
    state => state.components.auth.accountSummary
  );
  const {customer} = accountSummary;
  const functionType = customer.functionType;
  const dispatch = useDispatch();
  const isSkincare = functionType === 'SKINCARE_PRO';

  const isLabelNewFeature = () => {
    if (moment().unix() < moment('2024-10-15').unix()) {
      return true;
    }
    const createTime = _get(customer, 'createdTime');
    if (
      createTime &&
      moment().unix() * 1000 < createTime + 7 * 24 * 60 * 60 * 1000
    ) {
      return true;
    }
    return false;
  };

  return (
    <div className="kt-header__topbar-item" style={{position: 'relative'}}>
      <div className="kt-header__topbar-wrapper">
        <span
          className="kt-header__topbar-icon"
          id="help-menu-button"
          onClick={() => setShow(!show)}
        >
          <i className="fa fa-question-circle" style={{fontSize: 40}} />
          <span
            className="pl-2 d-flex kt-hidden-mobile"
            style={{height: 40, alignItems: 'center'}}
          >
            <Trans i18nKey="c.l.header.help.help">Help</Trans>
            {isLabelNewFeature() && (
              <div className="pf-smb-menu__new-feature__icon2 ml-1 mb-3" />
            )}
          </span>
        </span>
      </div>
      <div>
        <div
          className={classnames({
            'dropdown-menu': true,
            'dropdown-menu-right': true,
            'dropdown-menu-fit': true,
            'dropdown-menu-anim': true,
            'dropdown-menu-top-unround': true,
            'header-help__dropdown': true,
            show: show,
          })}
        >
          <div />
          <ul className="kt-nav">
            <li className="kt-nav__section kt-nav__section--first">
              <span className="kt-nav__section-text">
                <Trans i18nKey="c.l.header.help.title">help center</Trans>
              </span>
            </li>
            <span className="kt-nav__separator" />
            {isSkincare ? (
              <li className="kt-nav__item">
                <a
                  href="javascript:;"
                  className="kt-nav__link tutorial-skincare-start-guide"
                  onClick={() => history.push('/home/start-guide')}
                >
                  <span className="kt-nav__link-icon">
                    <i className="fa fa-info-circle" />
                  </span>
                  <span className="kt-nav__link-text">
                    <Trans i18nKey="c.l.header.help.start.guide">
                      Start Guide
                    </Trans>
                  </span>
                </a>
              </li>
            ) : (
              <li className="kt-nav__item">
                <a
                  href="javascript:;"
                  className="kt-nav__link"
                  onClick={() => dispatch(openTour())}
                >
                  <span className="kt-nav__link-icon">
                    <i className="fa fa-info-circle" />
                  </span>
                  <span className="kt-nav__link-text">
                    <Trans i18nKey="c.l.header.help.start.guide">
                      Start Guide
                    </Trans>
                  </span>
                </a>
              </li>
            )}
            <li className="kt-nav__item">
              <Link
                to="/support/tutorials/list-tutorials"
                className="kt-nav__link"
              >
                <span className="kt-nav__link-icon">
                  <i className="fa fa-play-circle" />
                </span>
                <span className="kt-nav__link-text d-flex">
                  <div>
                    <Trans i18nKey="c.l.header.help.tutorial.video">
                      Tutorial Videos
                    </Trans>
                  </div>
                  {isLabelNewFeature() && (
                    <div className="pf-smb-menu__new-feature__icon" />
                  )}
                </span>
              </Link>
            </li>
            <li className="kt-nav__item">
              <a
                href={frontendUtils.getFAQUrl('home-help')}
                target="_blank"
                rel="noreferrer noopener"
                className="kt-nav__link"
              >
                <span className="kt-nav__link-icon">
                  <i className="fa fa-file-signature" />
                </span>
                <span className="kt-nav__link-text">
                  <Trans i18nKey="c.l.header.help.faq">FAQ</Trans>
                </span>
              </a>
            </li>
            {!isSkincare && (
              <li className="kt-nav__item">
                <a
                  href={frontendUtils.getDocumentCenterUrl('home-help')}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="kt-nav__link"
                >
                  <span className="kt-nav__link-icon">
                    <i className="fa fa-book-open" />
                  </span>
                  <span className="kt-nav__link-text">
                    <Trans i18nKey="c.l.header.help.document.center">
                      API Document
                    </Trans>
                  </span>
                </a>
              </li>
            )}
            <li className="kt-nav__item">
              <Link className="kt-nav__link" to="/contactus/add-request">
                <span className="kt-nav__link-icon">
                  <i className="fa fa-edit" />
                </span>
                <span className="kt-nav__link-text">
                  {isSkincare ? (
                    <Trans i18nKey="p.contactus.technical.title">
                      Contact Us / Enable Technical Support
                    </Trans>
                  ) : (
                    <Trans i18nKey="p.contactus.title">Contact Us</Trans>
                  )}
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {show ? (
        <div className="dropdown-menu__popover">
          <div
            className="dropdown-menu__cover"
            onClick={() => setShow(false)}
          />
        </div>
      ) : null}
      <TutorialModal />
    </div>
  );
});
